import { createSlice } from '@reduxjs/toolkit'
import {
  fetchShipmentsData,
  putShipment,
  fetchShipmentStatusHistory,
  fetchShipmentById,
  checkProductShipmentDescription,
  createShipmentWaifRegister,
} from './thunk'

const initialState = {
  putShipmentLoading: false,
  shipmentError: null,

  shipmentStatusHistoryData: [],
  isFetchShipmentStatusHistoryLoading: false,
  fetchShipmentStatusHistoryError: undefined,

  shipmentByIdData: null,
  isFetchShipmentByIdLoading: false,
  fetchShipmentByIdError: null,

  shipmentsData: [],
  shipmentsDataError: null,
  shipmentsDataLoading: false,

  shipmentsList: [],
  shipmentsPage: 1,
  shipmentsHasMore: true,

  productShipmentDescriptionLoading: false,
  productShipmentDescriptionError: null,
  disableActionsAfterCheck: false,
  shipmentByIdOriginalData: null,

  shipmentWaifLoading: false,
}

const slice = createSlice({
  name: 'shipment',
  initialState,
  reducers: {
    resetShipmentsList: (state) => {
      state.shipmentsList = []
      state.shipmentsPage = 1
      state.shipmentsHasMore = true
    },
    resetShipmentByIdToOriginal: (state) => {
      if (state.shipmentByIdOriginalData) {
        state.shipmentByIdData = state.shipmentByIdOriginalData
      }
      state.disableActionsAfterCheck = false
    },
  },
  extraReducers: {
    [putShipment.pending]: (state) => {
      state.putShipmentLoading = true
    },
    [fetchShipmentStatusHistory.pending]: (state) => {
      state.isFetchShipmentStatusHistoryLoading = true
    },
    [fetchShipmentStatusHistory.fulfilled]: (state, action) => {
      state.isFetchShipmentStatusHistoryLoading = false
      state.shipmentStatusHistoryData = action.payload || []
    },
    [fetchShipmentStatusHistory.rejected]: (state, action) => {
      state.isFetchShipmentStatusHistoryLoading = false
      state.fetchShipmentStatusHistoryError = action.payload
    },
    [fetchShipmentById.pending]: (state) => {
      state.isFetchShipmentByIdLoading = true
      state.fetchShipmentByIdError = null
    },
    [fetchShipmentById.fulfilled]: (state, action) => {
      state.isFetchShipmentByIdLoading = false
      state.shipmentByIdData = action.payload
      state.shipmentByIdOriginalData = action.payload
      state.disableActionsAfterCheck = false
    },
    [fetchShipmentById.rejected]: (state, action) => {
      state.isFetchShipmentByIdLoading = false
      state.fetchShipmentByIdError = action.payload
    },
    [putShipment.fulfilled]: (state) => {
      state.putShipmentLoading = false
    },
    [putShipment.rejected]: (state, { error }) => {
      state.putShipmentLoading = false
      state.shipmentError = error
    },
    [fetchShipmentsData.pending]: (state) => {
      state.shipmentsDataLoading = true
      state.shipmentsDataError = null
    },
    [fetchShipmentsData.fulfilled]: (state, action) => {
      const { payload } = action
      state.shipmentsDataLoading = false
      state.shipmentsData = payload

      const page = Number(action?.meta?.arg?.page) || 1
      const offset = Number(action?.meta?.arg?.offset) || 50
      const content = Array.isArray(payload?.content) ? payload.content : []

      if (page === 1) {
        state.shipmentsList = content
      } else if (content.length) {
        state.shipmentsList = [...state.shipmentsList, ...content]
      }

      state.shipmentsPage = page

      const isLastByFlag = Boolean(payload?.last)
      const isLastBySize = content.length < offset
      state.shipmentsHasMore = !(isLastByFlag || isLastBySize)
    },
    [fetchShipmentsData.rejected]: (state, { error }) => {
      state.shipmentsDataLoading = false
      state.shipmentsDataError = error
      state.shipmentsHasMore = false
    },
    [checkProductShipmentDescription.pending]: (state) => {
      state.productShipmentDescriptionLoading = true
      state.productShipmentDescriptionError = null
    },
    [checkProductShipmentDescription.fulfilled]: (state, { payload }) => {
      state.productShipmentDescriptionLoading = false

      const product = payload?.result?.product
      if (!state.shipmentByIdData || !product) return

      const customDescription = product.customItemDescription
      const customCost = product.customItemPrice
      const customICount = product.customNumberOfItemPieces

      let wasChanged = false

      if (customDescription !== undefined && customDescription !== null) {
        state.shipmentByIdData.itemDescription = customDescription
        wasChanged = true
      }

      if (customCost !== undefined && customCost !== null) {
        state.shipmentByIdData.itemPrice = customCost
        wasChanged = true
      }

      if (customICount !== undefined && customICount !== null) {
        state.shipmentByIdData.numberOfItemPieces = customICount
        wasChanged = true
      }

      if (wasChanged) {
        state.disableActionsAfterCheck = true
      }
    },
    [checkProductShipmentDescription.rejected]: (state, { error, payload }) => {
      state.productShipmentDescriptionLoading = false
      state.productShipmentDescriptionError = payload || error
    },
    [createShipmentWaifRegister.pending]: (state) => {
      state.shipmentWaifLoading = true
    },
    [createShipmentWaifRegister.fulfilled]: (state) => {
      state.shipmentWaifLoading = false
    },
    [createShipmentWaifRegister.rejected]: (state) => {
      state.shipmentWaifLoading = false
    },
  },
})

export const { resetShipmentsList, resetShipmentByIdToOriginal } = slice.actions

export const reducer = slice.reducer
export const selectorShipment = (state) => state[slice.name]

export default slice
